module.exports = __webpack_public_path__ + "media/images/survivor_-9baac742352352e4a794e14ebd306738.svg";